export default function () {
  this.loadReports()
}
